import { render, staticRenderFns } from "./Regulation.vue?vue&type=template&id=65f77213"
import script from "./Regulation.vue?vue&type=script&lang=js"
export * from "./Regulation.vue?vue&type=script&lang=js"
import style0 from "./Regulation.vue?vue&type=style&index=0&id=65f77213&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports